
import { assertInInjectionContext, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { ProfileModel } from '@tsin-core/store/auth/auth.model';
import { AuthState } from '@tsin-core/store/auth/auth.state';
import { environment } from '@tsin-env/environment';
import { hasAdminRole } from '@tsin-shared/utils/user-utils';



const canActivateChildFn: CanActivateFn = () => {
  assertInInjectionContext(canActivateChildFn);
  const router: Router = inject(Router);
  const store: Store = inject(Store);

  const isLogin = store.selectSignal(AuthState.getToken);

  // console.log('Admin Guard Token', isLogin);

  if (!!isLogin) {
    const profiles: ProfileModel[] | null = store.selectSnapshot<ProfileModel[] | null>(AuthState.getProfiles);
    const isManager: boolean = profiles == null ? false: hasAdminRole(profiles);
    console.info(`Is Staff ${isManager}, will activate`);
    if (isManager) {
      return true;
    }
    return router.parseUrl('/account');
  }

  return router.parseUrl('/login');
};

export const adminGuard: CanActivateFn = (route, state) => {
  return canActivateChildFn(route, state);

};
